<template>
  <div class="wrapper">
    <div class="action menu" @click="toggleVisibility">
      <svgicon v-if="icon.indexOf('svg') > -1" :src="icon" :height="20" :width="20"></svgicon>
      <img v-if="icon.indexOf('svg') === -1" :src="icon">
      <div class="menu-items" :class="{visible: headerMenuVisible}">
        <slot></slot>
        <div class="arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from "vue";
  import Popper from "popper.js";

  export default {

    name: "ActionMenu",

    props: {
      icon: String
    },

    data() {
      return {
        headerMenuVisible: false,
        popper: null
      };
    },

    methods: {
      toggleVisibility(e) {
        this.headerMenuVisible = !this.headerMenuVisible;
        if (this.headerMenuVisible) {
          let anchor = this.$el.querySelector(".action.menu");
          let target = this.$el.querySelector(".menu-items");
          let arrow = this.$el.querySelector(".arrow");
          this.popper = new Popper(anchor, target, {
            placement: "bottom",
            modifiers: {
              preventOverflow: {
                enabled: true
              },
              hide: {
                enabled: false
              },
              arrow: {
                element: arrow
              },
              flip: {
                behavior: ["bottom"]
              },
            }
          });
          this.popper.scheduleUpdate();
          setTimeout(() => {
            this.popper.scheduleUpdate();
          }, 1);
        } else if (this.popper != null) {
          this.popper.destroy();
        }
        e.stopPropagation();
      }
    }

  };

</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .svgicon {
    fill: #808b91;
  }
  .menu {
    cursor: pointer;
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .menu-items {
    display: none;

    &.visible {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      background-color: white;
      color: #404040;
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
      z-index: 4;
    }

    a,
    div,
    span {
      color: #404040;
      text-decoration: none;
      font-size: 16px;

      &:hover {
        color: var(--primary-color);
      }
    }
  }

  .arrow {
    background-color: white;
    width: 26px;
    height: 26px;
    position: absolute;
    top: -10px;
    transform: rotateZ(45deg);
    border-bottom-right-radius: 100px;
    box-shadow: rgba(0, 0, 0, 0.05) -2px -2px 3px 0px;
  }
</style>

<style lang="scss">
  .menu-items .item {
    padding: 10px 20px;

    &:first-child {
      padding-top: 20px;
    }

    &:last-of-type {
      padding-bottom: 20px;
    }
  }
</style>